import { routes } from '@cedarjs/router'

import {
  useIsGov,
  useIsGovWellStaff,
  useMyOrg,
  useMyRecordTypes,
  useMyUser,
} from '../layouts/AppStateContextLayout/utils'
import { getReverseTrialDaysLeftInTimeZone } from '../utils/aicaReverseTrial'

const AICA_TRIAL_EXPIRING_SOON_DAYS = 60
const AICA_TRIAL_TIERS = new Set(['AicaLegacyTrial', 'AicaReverseTrial'])

const useIsAicaTrialExpiringSoon = (): boolean => {
  const org = useMyOrg()
  if (!org || !AICA_TRIAL_TIERS.has(org.aiResidentAssistantUsageTier)) {
    return false
  }
  const daysLeft = getReverseTrialDaysLeftInTimeZone(org.trialEndDate, org.timeZone)
  return daysLeft !== undefined && daysLeft <= AICA_TRIAL_EXPIRING_SOON_DAYS
}

export const useHomePage = () => {
  const isGov = useIsGov()
  const isGovWellStaff = useIsGovWellStaff()
  const recordTypes = useMyRecordTypes()
  const me = useMyUser()
  const isAicaTrialExpiringSoon = useIsAicaTrialExpiringSoon()

  if (isGovWellStaff) {
    return routes.adminOrgs()
  }
  if (isGov) {
    if (recordTypes?.length) {
      if (me?.group === 'Reviewer') {
        return routes.tasks()
      }

      const isAdminOrAIAdmin = me?.group === 'Admin' || !!me?.isAIStaffMember
      if (isAdminOrAIAdmin && isAicaTrialExpiringSoon) {
        return routes.communityAssistantInsights()
      }

      return routes.insights()
    }
    return routes.settings()
  } else {
    return routes.citizenRecords()
  }
}
